const state = {
  regActiveIndex: 0
}

const actions = {
}

const mutations = {
  setRegActiveIndex (state, {index}) {
    state.regActiveIndex = index
  }
}

export default {
  state,
  mutations,
  actions
}
